// extracted by mini-css-extract-plugin
export default {"contact":"SupportPage_contact__mh9W5","contactInfo":"SupportPage_contactInfo__KFqe-"};